import React from 'react';
import AIChatModal from './ai-modal';
import classNames from 'classnames';
import styles from 'hellospa/components/global-nav/global-nav.scss';
import { Text } from '@dropbox/dig-components/typography';
import { Button } from '@dropbox/dig-components/buttons';
import { PageSource } from './common/utils';
import './index.scss';
import * as uuid from 'uuid';
import { useOnMount } from 'js/sign-components/common/hooks';
import { useAppContext } from 'hello-react/web-app-client';
import SignAiChatItem from './common/sign-ai-chat-item';
import { UserSurvey, UserSurveyEvent, UserSurveyPosition } from 'common/utils/user_survey';

type AIChatTypes = {
  openAiContextId: string
  source: PageSource
  preloadedTsmGroupKey?: boolean
};

const AIChat = ({
  openAiContextId,
  source,
  preloadedTsmGroupKey = false,
}: AIChatTypes) => {
  const { signAi } = useAppContext();

  const [state, setState] = React.useState(false);
  const [transformedContextId, setTransformedContextId] = React.useState<string | null>(null);
  const [accountGuid, setAccountGuid] = React.useState<string | null>(null);

  const fetchTsmGroupGuid = async () => {
    const data = await signAi.getTsmGroupGuidFromPreloadedKey({
      preloadedTsmGroupKey: openAiContextId,
    });
    if (data) {
      setTransformedContextId(data.tsmGroupGuid);
    } else {
      setTransformedContextId(null);
    }
  };

  const fetchUserData = async () => {
    const data = await signAi.getUserData();
    setAccountGuid(data?.account?.guid ?? null);
  };

  const openModal = () => {
    setState(true);
  };
  const abort = () => {
    UserSurvey.addAttribute('app_source', source);
    if (transformedContextId) {
      UserSurvey.addAttribute('context_id', transformedContextId);
    }
    UserSurvey.setPosition(UserSurveyPosition.Center);
    UserSurvey.trackEvent(UserSurveyEvent.SignAIServiceOutToOffice);
    setState(false);
  };

  useOnMount(() => {
    if (preloadedTsmGroupKey) {
      fetchTsmGroupGuid();
    } else {
      setTransformedContextId(source === PageSource.Home ? uuid.v4() : openAiContextId);
    }
    fetchUserData();
  });

  return (
    <>
      {source === PageSource.Home && (
        <div className={classNames(styles.navItem)} data-qa-ref='global-nav-sign-ai-link'
          data-testid='global-nav-sign-ai-link'
        >
          <a onClick={openModal}>
            <Text size="large" className={styles.navItemText}>
              <SignAiChatItem />
            </Text>
          </a>
        </div>
      )}
      {source !== PageSource.Home && (
        <Button variant='opacity' onClick={openModal} data-testid='ai-chat-button' className={source === PageSource.SignerApp ? 'aiChatItem' : ''}>
          <SignAiChatItem />
        </Button>
      )}
      {transformedContextId && accountGuid && <AIChatModal
        iframeUrl={`https://signspa.staging-hellosign.com/#/?context=${transformedContextId}&source=${source}&account_id=${accountGuid}`}
        open={state}
        onAbort={abort} />
      }
    </>
  );
};

export default AIChat;
